import { defineComponent as _defineComponent } from 'vue'

import Icon from "@/components/widgets/icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'QuizIntro',
  props: {
    title: null,
    description: null,
    disabled: { type: Boolean },
    showNext: { type: Boolean }
  },
  emits: ["start", "next"],
  setup(__props: any, { emit }) {

const { title, description, disabled, showNext } = __props as {
  title: string
  description: string
  disabled?: boolean
  showNext?: boolean
}





const onNextClick = () => {
  emit("next")
}

return { __sfc: true,emit, onNextClick, Icon }
}

})